import { keyframes, styled } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react';

import { ICategoryItem } from '../../../categories/interfaces';
import { ReactComponent as MenuBtnLoader } from '../../../../../../_base/layout/assets/layout-svg-icons/menu-button-loader.svg';
import { ReactComponent as MenuBtn } from '../../../../../../_base/layout/assets/layout-svg-icons/menu-button.svg';
import { useStylesProductCatalog } from '../../hooks/useStyles';
import { useGetChildrenCategories } from '../../hooks/useGetChildrenCategories';

const rotate = keyframes`
  100% {
    transform: rotate(360deg);
  }
`;

const RotatingIcon = styled('div')(() => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  animation: `${rotate} ${1}s linear infinite`,
}));

const RenderCatalogTree = ({
  categoryChildren,
  onPressCategory,
}: {
  categoryChildren: ICategoryItem[];
  onPressCategory?: (e: any) => void;
}) => {
  const { classes } = useStylesProductCatalog();

  return categoryChildren?.length ? (
    <div>
      {categoryChildren
        .filter(j => j?.active)
        .map(j => (
          <Fragment key={j.id}>
            <p className={classes.categoryItem} onClick={() => onPressCategory?.(j)}>
              {j.name}
            </p>
          </Fragment>
        ))}
    </div>
  ) : null;
};

const CatalogCategory = ({
  cat,
  handlePressCategoryTitle,
  onPressCategory,
  updateCatalog,
}: {
  cat: ICategoryItem;
  handlePressCategoryTitle: (category: ICategoryItem) => void;
  onPressCategory: (category: ICategoryItem) => void;
  updateCatalog: (newCategories: ICategoryItem[], id: number) => void;
}) => {
  const { classes } = useStylesProductCatalog();
  const [showChildren, setShowChildren] = useState(false);
  const {
    fetch: fetchChildren,
    categories: categoryChildren,
    loading,
  } = useGetChildrenCategories(updateCatalog);

  useEffect(() => {
    if (showChildren && cat.id) {
      fetchChildren({
        id: cat.id,
        per_page: 300,
        only_active: 1,
        with_products: 1,
      });
    }
  }, [showChildren]);

  return (
    <div
      style={{
        backgroundColor: '#f7f7f7',
        borderRadius: '8px',
        padding: '16px',
        margin: '16px 0',
      }}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          alignItems: 'center',
          cursor: 'pointer',
        }}
        onClick={() => setShowChildren(state => !state)}
      >
        <p className={classes.subTitle} onClick={() => handlePressCategoryTitle(cat)}>
          {cat.name}
        </p>
        {cat.count_children_active && cat.count_children_active > 0 ? (
          <div style={{ height: 44 }}>
            {loading && showChildren ? (
              <RotatingIcon>
                <MenuBtnLoader />
              </RotatingIcon>
            ) : (
              <MenuBtn
                style={{ transform: !showChildren ? 'rotate(90deg)' : 'rotate(270deg)' }}
              />
            )}
          </div>
        ) : null}
      </div>
      {showChildren && !loading && (
        <RenderCatalogTree
          categoryChildren={categoryChildren || []}
          onPressCategory={onPressCategory}
        />
      )}
    </div>
  );
};

export default CatalogCategory;
